import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { connect } from 'react-redux';
import { Button, ButtonContainer, ModalFooter } from '@emburse/ui-core';
import { Icon } from '@ReactComponents/Icon';
import { WizardPanel } from '@ReactComponents/Wizard/Wizard';
import { ReviewCardHolders, UpdateAddCardDiffCardHolder } from '@Actions/index';
import { ManualUploadSingleCardHolderMapping } from '../ManualUploadSingleCardHolderMapping';
// Styles
import * as style from './ManualUploadCardProgramCardMapping.styl';
export class ManualUploadCardProgramCardMapping extends WizardPanel {
    constructor(props) {
        super(props);
    }
    onReview() {
        this.props.onReview();
        this.props.changePanel('summary');
    }
    onBackout() {
        this.props.onBackout();
        this.props.changePanel('start');
    }
    render() {
        const cardProgram = this.props.cardProgram;
        const onChangeCardHolder = this.props.onChangeCardHolder;
        const countCurrentCardHolders = (cardProgram.subaccounts && cardProgram.subaccounts.length) || 0;
        const addCardDiffs = this.props.addCardDiffs;
        const addTransactionDiffs = this.props.addTransactionDiffs;
        const users = this.props.users;
        const mappingComponents = addCardDiffs.map(function (cardDiff) {
            const countOfNewTransactions = addTransactionDiffs.filter(function (transactionDiff) {
                return transactionDiff.accountId === cardDiff.id;
            }).length;
            return (_jsx(ManualUploadSingleCardHolderMapping, { addCardDiff: cardDiff, users: users, countOfNewTransactions: countOfNewTransactions, onChangeCardHolder: (user) => onChangeCardHolder(cardDiff.id, user.id) }, cardDiff.id));
        });
        const noun = mappingComponents.length === 1 ? 'card holder' : 'card holders';
        return (_jsxs("div", Object.assign({ className: style.global }, { children: [_jsxs("div", { children: [_jsxs("p", { children: ["This program currently has ", _jsx("strong", { children: countCurrentCardHolders }), " card holders. We identified", ' ', _jsx("strong", { children: mappingComponents.length }), " new ", noun, " from the statement you uploaded. Please review and correct any information below."] }), mappingComponents] }), _jsx(ModalFooter, { children: _jsxs(ButtonContainer, Object.assign({ alignButtons: "right" }, { children: [_jsx(Button, Object.assign({ variant: "outlined", onClick: () => this.onBackout() }, { children: "Back" })), _jsxs(Button, Object.assign({ primary: true, onClick: () => this.onReview() }, { children: ["Review Transactions", _jsx(Icon, { small: true, name: "right-arrow-small" })] }))] })) })] })));
    }
}
// Connected Component
const mapStateToProps = (state, parentProps) => {
    const s = state.cardStatementUpload;
    const users = state.users.users;
    return Object.assign(Object.assign({}, parentProps), { users, error: s.error, allDiffs: s.allDiffs, addCardDiffs: s.addCardDiffs, addTransactionDiffs: s.addTransactionDiffs, errorDiffs: s.errorDiffs });
};
const mapDispatchToProps = (dispatch) => ({
    onChangeCardHolder: (temporaryAccountId, userId) => {
        dispatch(new UpdateAddCardDiffCardHolder(temporaryAccountId, userId));
    },
    onReview: () => dispatch(new ReviewCardHolders(true)),
    onBackout: () => dispatch(new ReviewCardHolders(false))
});
export const ConnectedManualUploadCardProgramCardMapping = connect(mapStateToProps, mapDispatchToProps)(ManualUploadCardProgramCardMapping);
